import { createAsyncThunk } from "@reduxjs/toolkit"
import { asyncThunkWrapper } from "../thunkHandler"
import { BASEURI, headers } from "../../utils/helper"
import axios from "axios"

// --------------- Handle create new chat ---------------
export const handleCreateNewChat = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    try {
      const response = await axios({
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/user/chat/create`,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error);
    }
  }
)

// --------------- Handle accept chat ---------------
export const handleAcceptNewChat = createAsyncThunk(
  "create",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/user/chat/accept/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// --------------- Handle reject chat ---------------
export const handleRejectNewChat = createAsyncThunk(
  "create",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/user/chat/reject/${id}`,
      },
      thunkAPI
    )
  }
)

// --------------- Handle upload chat files ---------------
export const handleUploadFiles = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/user/chat/upload`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)